import { useCallback, useState } from 'react';

import { useLocalStorageState } from '@/utils/use-local-storage-state';

export const useConfirmationModal = (
  handleMarkDoneParent: () => void,
  handleMoveToEndParent: () => void,
  handleLeftClickParent: () => void,
  handleRightClickParent: () => void
) => {
  const [hasEdited, setHasEdited] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState<
    (() => void) | null
  >(null);
  const [dontShowConfirmationAgain, setDontShowConfirmationAgain] =
    useLocalStorageState('ls:annotation_queue_confirmation', false);

  const maybeOpenConfirmationModal = useCallback(
    (func: () => void) => {
      if (hasEdited && !dontShowConfirmationAgain) {
        setIsConfirmationModalOpen(() => func);
      } else {
        func();
      }
    },
    [dontShowConfirmationAgain, hasEdited]
  );

  const handleMarkDone = useCallback(() => {
    maybeOpenConfirmationModal(handleMarkDoneParent);
  }, [maybeOpenConfirmationModal, handleMarkDoneParent]);

  const handleMoveToEnd = useCallback(() => {
    maybeOpenConfirmationModal(handleMoveToEndParent);
  }, [maybeOpenConfirmationModal, handleMoveToEndParent]);

  const handleLeftClick = useCallback(() => {
    maybeOpenConfirmationModal(handleLeftClickParent);
  }, [maybeOpenConfirmationModal, handleLeftClickParent]);

  const handleRightClick = useCallback(() => {
    maybeOpenConfirmationModal(handleRightClickParent);
  }, [maybeOpenConfirmationModal, handleRightClickParent]);

  return {
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
    handleMarkDone,
    handleMoveToEnd,
    handleLeftClick,
    handleRightClick,
    setDontShowConfirmationAgain,
    hasEdited,
    setHasEdited,
  };
};
